import Ajv, { ValidateFunction, ErrorObject } from 'ajv';
import { isDefined } from './Micro';
import _ from 'lodash';
import { DebugEx } from './DebugEx';
// --------------------------------------------------------------------------------------------------
export interface ISchemaValidatorRsp {
    valid: boolean;
    errors: ErrorObject[] | string;
    warning?: string;
}
// --------------------------------------------------------------------------------------------------
export class JsonSchemaValidator {
    // --------------------------------------------------------------------------------------------------
    private ajv: Ajv;
    private validate: ValidateFunction<any>;
    private extraValidator: (data: any) => ISchemaValidatorRsp;
    // --------------------------------------------------------------------------------------------------
    private static instances: { [key: string]: JsonSchemaValidator } = {};
    static GetInstance(uid: string, options: any, defsSchema: any = null, extraValidator: (data: any) => ISchemaValidatorRsp = null) {
        let validator = JsonSchemaValidator.instances[uid];
        if (!isDefined(validator)) {
            validator = JsonSchemaValidator.instances[uid] = new JsonSchemaValidator(options, defsSchema, extraValidator);
        }
        return validator;
    }
    // --------------------------------------------------------------------------------------------------
    private constructor(options, defsSchema = null, extraValidator = null) {
        this.ajv = new Ajv({
            allErrors: true,
            verbose: true,
            strict: false
            //nullable: true
        });
        if (isDefined(defsSchema))
            this.ajv.addSchema(defsSchema)
        this.validate = this.ajv.compile(options);
        this.extraValidator = extraValidator;
    }
    // --------------------------------------------------------------------------------------------------
    private _errorObjToStr(): string {
        return _.map(this.validate.errors, v => `${v.instancePath} : ${v.message}`).join(',\n ');
    }
    // --------------------------------------------------------------------------------------------------
    private _validate(data: any, stringErrorMsg: boolean): ISchemaValidatorRsp {
        if (this.validate(data)) {
            // Initialize successful validation response.
            let rsp: ISchemaValidatorRsp = {
                valid: true,
                errors: null
            };

            // Needs extra validation?
            if (isDefined(this.extraValidator)) {
                try {
                    // Return response if any.
                    const res: ISchemaValidatorRsp = this.extraValidator(data);
                    if (isDefined(res))
                        return res;
                }
                catch (e) { DebugEx.TraceError(e); }
            }
            return rsp;
        }
        else {
            // Validation has errors.
            return {
                valid: false,
                errors: stringErrorMsg
                    ? this._errorObjToStr()
                    : this.validate.errors
            }
        }
    }
    // --------------------------------------------------------------------------------------------------
    DataValidate(data: any): ISchemaValidatorRsp {
        return this._validate(data, false);
    }
    // --------------------------------------------------------------------------------------------------
    DataValidateString(data: any): ISchemaValidatorRsp {
        return this._validate(data, true);
    }
    // --------------------------------------------------------------------------------------------------
}
// --------------------------------------------------------------------------------------------------